(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-story-carousel')) {
    class BrandStoryCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.slides = Array.from(this.querySelectorAll('[data-brand-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-brand-dot]'));
        this.previousButton = this.querySelector('[data-brand-previous]');
        this.nextButton = this.querySelector('[data-brand-next]');
        this.autoplayButton = this.querySelector('[data-brand-autoplay]');
        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.pointerStart = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
        this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true));
        });
        this.autoplayButton?.addEventListener('click', () => this.toggleAutoplay());

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.addEventListener(
          'touchstart',
          (event) => {
            this.pointerStart = event.changedTouches[0].clientX;
            this.stop();
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (event) => {
            if (this.pointerStart === null) return;
            const distance = event.changedTouches[0].clientX - this.pointerStart;
            if (Math.abs(distance) > 45) {
              this.show(distance > 0 ? this.currentIndex - 1 : this.currentIndex + 1, true);
            }
            this.pointerStart = null;
            this.start();
          },
          { passive: true }
        );
        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-brand-slide]');
          if (!selectedSlide) return;
          this.userPaused = true;
          this.updateAutoplayButton();
          this.show(Number(selectedSlide.dataset.index), false);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index, userInitiated) {
        if (this.slides.length < 2) return;
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          const link = slide.querySelector('a');
          if (link) link.tabIndex = isActive ? 0 : -1;
        });
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        if (userInitiated) this.restart();
      }

      start() {
        if (!this.autoplayEnabled || this.userPaused || this.reducedMotion || this.slides.length < 2) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        this.updateAutoplayButton();
        if (this.userPaused) {
          this.stop();
        } else {
          this.start();
        }
      }

      updateAutoplayButton() {
        if (!this.autoplayButton) return;
        this.autoplayButton.classList.toggle('is-paused', this.userPaused);
        this.autoplayButton.setAttribute(
          'aria-label',
          this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel
        );
      }
    }

    customElements.define('brand-story-carousel', BrandStoryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
